import { forwardRef, useId } from 'react';
import type { RadioProps } from './Radio.types';
import './Radio.scss';

const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, description, id, className, disabled, ...rest },
  ref,
) {
  const autoId = useId();
  const rId = id || `radio-${autoId}`;
  return (
    <label
      htmlFor={rId}
      className={['radio', disabled ? 'radio--disabled' : '', className || ''].filter(Boolean).join(' ')}
    >
      <span className="radio__control">
        <input ref={ref} id={rId} type="radio" className="radio__native" disabled={disabled} {...rest} />
        <span className="radio__circle" aria-hidden="true">
          <span className="radio__dot" />
        </span>
      </span>
      {label || description ? (
        <span className="radio__text">
          {label ? <span className="radio__label">{label}</span> : null}
          {description ? <span className="radio__description">{description}</span> : null}
        </span>
      ) : null}
    </label>
  );
});

export default Radio;
